import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormGroup,FormBuilder,Validators,FormArray,FormControl} from '@angular/forms';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { TransactionResult } from '../../../../core/services/interfaces/transaction-result';
import {DatePipe} from '@angular/common';
import { IScreens } from '../Interfaces/IScreens';
import { ILastReleases } from '../Interfaces/ILastReleases';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { PropertiesService } from '../services/properties-services';
import { RolesService } from '../services/roles-service';
import { Router } from '@angular/router';
import { IEmployees } from '../Interfaces/IEmployees';
import { EmployeesService } from '../services/employees-service';
import { IProperties } from '../Interfaces/IProperties';
import { Dropdown } from 'primeng/dropdown';
import { IEmployeesInActiveDirectory } from '../Interfaces/IEmployeesInActiveDirectory';
import { ActiveDirectoryService} from '../services/activedirectory-services';
declare var jQuery:any;

export interface ISelect {
  value: string;
  distinguishedname: string;
}

@Component({
  selector: 'jabil-search-employee',
  templateUrl: './jabil-search-employee.component.html',
})
export class JabilSearchEmployee implements OnInit {
  @Output() changeValue: EventEmitter<any> = new EventEmitter();
  @Output() clearSelect: EventEmitter<any> = new EventEmitter();
  @Input() isReadOnly: boolean = false;
  loading = false;
  listData: Array<ISelect> = [];
  searching: boolean = false;
  searched:boolean = false;
  style: string;
  value: any;
  dropDown: Dropdown;
  OnChange = (_: any) => { };
  OnTouch = () => { };

  constructor(
    private cognito: CognitoService,
    private datePipe: DatePipe,
    private notificationService: NotificationService,
    public translate: TranslateApplicationService,
    private propertyService: PropertiesService,
    private employeesService: EmployeesService,
    private activeDirectoryService: ActiveDirectoryService,
    public router: Router
  ) {}

  ngOnInit() {
    jQuery(".p-dropdown").css('width','300px');
  }
  
  OnKeyUp(event, employees: Dropdown) {
    if (event.filter != null && event.filter.length >= 4 && !this.searching && !this.searched) {
      this.searching = true;
      this.dropDown = employees;
      this.GetEmployeeByEmailNumberName(event.filter);
    }
    if(event.filter != null && event.filter.length < 4) this.searched = false;
  }
  OnSelected(value: any) {
    this.value = value;
    this.OnTouch();
    this.OnChange(this.value);
    this.changeValue.emit(this.value);
  }
  ClearDropDown() {
    if (this.dropDown != undefined) {
      this.dropDown.resetFilter();
      this.listData = [];
      this.clearSelect.emit(this.value);
    }
  }

  GetEmployeeByEmailNumberName(value: string) {
		this.loading = true;
		var arr: IEmployeesInActiveDirectory[] = [];
		this.activeDirectoryService
			.GetEmployeeByEmailNumberName(value)
			.subscribe(
				(result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
					this.loading = false;
					this.searching = false;
					this.searched = true;

					if (result.success) {
						var jsonObj = JSON.parse(result.data.toString());
						arr = jsonObj.data;
						jsonObj.data.name;

						arr.forEach((obj) => {
							let option: ISelect = {
								value: obj.name,
								distinguishedname: obj.distinguishedname,
							};
							this.listData.push(option);
						});
					}
				},
				(error: any) => {
					this.loading = false;
				},
			);
  }
  
  registerOnChange(fn: any): void { this.OnChange = fn; }
  registerOnTouched(fn: any): void { this.OnTouch = fn; }
}